import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface SetEnabledStatusForSchedulesParams extends IMultipleIdsParams {
  enabled: boolean;
}

export class SetEnabledStatusForSchedulesRequest extends Request<SetEnabledStatusForSchedulesParams, IResult> {
  constructor(ids: string[], enabled: boolean) {
    super('setEnabledStatusForSchedules', { ids: ids, enabled: enabled });
  }
}
